module.exports = __webpack_public_path__ + "static/media/BwModelica-Bold.b78b07d7.otf";